import { Component, OnInit, Inject } from '@angular/core';
import { BaseDialog } from '../../../base-dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AddressResponseItem } from '../../../services/api/profile-address.service';

@Component({
  selector: 'mandae-address-remove-dialog',
  templateUrl: './address-remove-dialog.component.html',
  styleUrls: ['./address-remove-dialog.component.scss']
})
export class AddressRemoveDialogComponent extends BaseDialog<AddressRemoveDialogComponent> implements OnInit {

  public address: AddressResponseItem;

  constructor(@Inject(MAT_DIALOG_DATA) data, dialogRef: MatDialogRef<AddressRemoveDialogComponent>) {
    super(dialogRef);

    this.address = data.address;
  }

  ngOnInit() {
  }

}
